import styled from 'styled-components';
import { rem } from '@/styles/theme';

interface IProps {
  hasButton?: string | null;
  theme: any;
  // avatarType?: string;
}

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: ${rem(30)};
  background: ${({ theme }) => theme.color.white};
  border: 1px solid ${({ theme }) => theme.color['gray-200']};
  ${({ theme }) => theme.media.fold`
    border-radius: ${rem(26)};
  `}
`;

export const TopArea = styled.div<IProps>`
  position: relative;
  aspect-ratio: ${({ hasButton }) => (hasButton ? 1 / 0.41812865497 : 1 / 0.58771929824)};
  img {
    object-fit: cover;
    width: 100%;
  }
`;
export const BottomArea = styled.div<IProps>`
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  gap: ${rem(18)};

  ${({ hasButton }) =>
    hasButton
      ? `
    padding: ${rem(18)} ${rem(24)} ${rem(20)};
  `
      : `
    padding: ${rem(20)} ${rem(24)};
  `}

  ${({ theme }) => theme.media.fold`
    padding: ${rem(18)} ${rem(20)};
  `}

  ${({ hasButton, theme }) =>
    hasButton &&
    theme.media.fold`
    padding: ${rem(16)} ${rem(20)} ${rem(18)};
  `}
`;

export const CardArea = styled.div<IProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${rem(16)};
  ${({ theme }) => theme.media.fold`
    gap: ${rem(12)};
  `}
`;

export const CardTextArea = styled.div<IProps>`
  display: flex;
  flex-direction: column;
  gap: ${rem(2)};
  overflow: hidden;
`;

export const Image = styled.img``
